
import { useEffect } from "react";
import socket from "./socket";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import MainLayout from "./components/layout/MainLayout";

import Login from "./pages/Login";
import BossDashboard from "./dashboard/BossDashboard";
import TelesalesDashboard from "./dashboard/TelesalesDashboard";
import FollowUps from "./pages/FollowUps";
import CallLogs from "./pages/CallLogs";
import DailySummary from "./pages/DailySummary";
import Profile from "./pages/Profile";
import ITDashboard from "./dashboard/ITDashboard";
import PackagesPage from "./pages/PackagesPage";
import ServicesPage from "./pages/ServicesPage";
import SupportPage from "./pages/SupportPage";
import Users from "./pages/Users";
import SalesExecDashboard from "./dashboard/SalesExecDashboard";
import Notifications from "./pages/Notifications";
import Meetings from "./pages/Meetings";      
import AddEmployee from "./pages/AddEmployee";
import EmployeesPage from "./pages/EmployeesPage";
import Settings from "./pages/Settings";
import SalesManagerDashboard from "./dashboard/SalesManagerDashboard";
import AssignedLeads from "./pages/AssignedLeads";
import PerformanceReport from "./pages/PerformanceReport";

import { ToastProvider } from "./components/common/Toast";

/* NEW: Target Management + Notification System pages */
import MyTarget from "./pages/employee/MyTarget";
import SubmitAchievement from "./pages/employee/SubmitAchievement";
import TargetManagement from "./pages/admin/TargetManagement";
import TargetAchievementsAdmin from "./pages/admin/TargetAchievementsAdmin";
import ActivityLogs from "./pages/admin/ActivityLogs";
import GlobalDataExplorer from "./pages/admin/GlobalDataExplorer";
import SalesCallLogs from "./pages/admin/SalesCallLogs";


/* Protected Route */
const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  return token ? children : <Navigate to="/login" />;
};

function App() {
  useEffect(() => {
  const userId = localStorage.getItem("userId");

  if (userId) {
    socket.emit("join", userId);  // 🔥 USER CONNECT ROOM
    console.log("Joined socket room:", userId);
  }
}, []);



  return (
    <BrowserRouter>
    <ToastProvider>
      <Routes>

        {/* Public */}
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />

       
     {/* 👑 BOSS ROUTES */}
<Route 
  path="/boss" 
  element={
    <PrivateRoute>
      <MainLayout />
    </PrivateRoute>
  }
>
  <Route index element={<BossDashboard />} />
<Route path="salesexec">
  <Route index element={<SalesExecDashboard />} />
  <Route path=":id" element={<SalesExecDashboard />} />
</Route>
  <Route path="meetings" element={<Meetings />} />
  <Route path="calllogs" element={<SalesCallLogs />} />
  <Route path="followups" element={<FollowUps />} />
  <Route path="employees" element={<EmployeesPage />} />
  <Route path="add-employee" element={<AddEmployee />} />
<Route path="telesales">
  <Route index element={<TelesalesDashboard />} />
  <Route path=":id" element={<TelesalesDashboard />} />
</Route>
<Route path="notifications" element={<Notifications />} />
  <Route path="itmanager" element={<ITDashboard />} />
  <Route path="settings" element={<Profile />} />

  {/* NEW: Target Management + Notification System (Admin) */}
  <Route path="target-management" element={<TargetManagement />} />
  <Route path="achievements" element={<TargetAchievementsAdmin />} />
  <Route path="activity-logs" element={<ActivityLogs />} />
  <Route path="global-explorer" element={<GlobalDataExplorer />} />

</Route>

       
        

        {/* Telesales */}
        
        <Route 
  path="/telesales" 
  element={
    <PrivateRoute>
      <MainLayout />
    </PrivateRoute>
  }
>
  <Route index element={<TelesalesDashboard />} />
  <Route path="meetings" element={<Meetings />} />
  <Route path="followups" element={<FollowUps />} />
  <Route path="calllogs" element={<CallLogs />} />
  <Route path="dailysummary" element={<DailySummary />} />
  <Route path="settings" element={<Settings />} />
  <Route path="notifications" element={<Notifications />} />
  <Route path="packages" element={<PackagesPage />} />

  {/* NEW: Target + Achievement (Employee) */}
  <Route path="my-target" element={<MyTarget />} />
  <Route path="submit-achievement" element={<SubmitAchievement />} />
</Route>

        {/* Sales Executive */}
     <Route
  path="/salesexec"
  element={
    <PrivateRoute>
      <MainLayout />
    </PrivateRoute>
  }
>
  <Route index element={<SalesExecDashboard />} />
  <Route path="calllogs" element={<CallLogs />} />
  <Route path="followups" element={<FollowUps />} />
  <Route path="notifications" element={<Notifications />} />
  <Route path="dailysummary" element={<DailySummary />} />
  <Route path="meetings" element={<Meetings />} /> 
  <Route path="packages" element={<PackagesPage />} />
  <Route path="settings" element={<Settings />} />

  {/* NEW: Target + Achievement (Employee) */}
  <Route path="my-target" element={<MyTarget />} />
  <Route path="submit-achievement" element={<SubmitAchievement />} />
</Route>
  

<Route
  path="/itmanager"
  element={
    <PrivateRoute>
      <MainLayout />
    </PrivateRoute>
  }
>
  <Route index element={<ITDashboard />} />
  <Route path="packages" element={<PackagesPage />} />
  <Route path="services" element={<ServicesPage />} />
 <Route path="employees" element={<EmployeesPage />} />
  <Route path="support" element={<SupportPage />} />
  <Route path="notifications" element={<Notifications />} />
  <Route path="settings" element={<Settings />} />
</Route>




        {/* Sales Manager */}
        <Route
          path="/manager"
          element={
            <PrivateRoute>
              <MainLayout />
            </PrivateRoute>
          }
        >
          <Route index element={<SalesManagerDashboard />} />
          <Route path="leads" element={<AssignedLeads />} />
          <Route path="team" element={<EmployeesPage />} />
          <Route path="performance" element={<PerformanceReport />} />
          <Route path="settings" element={<Settings />} />
        </Route>

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/login" />} />
         
      </Routes>
    </ToastProvider>
    </BrowserRouter>
  );


  
}

export default App;